import React, {useState, useEffect, useRef} from "react";
import request from "../../../app/api/requests";
import { useNavigate, useLocation } from "react-router-dom";
import { resolveSubscriptionReturn } from '../../../entities/subscription/model/payment-return-location';
import { Link } from "react-router-dom";
import { sendDataLayer } from "../../../shared/lib/sendDataLayer";
import { startSession } from '../../../shared/lib/auth/session';
import Validation from "../../../shared/ui/Validation/Validation";
import { useDispatch } from "react-redux";
import { ReactComponent as UserEmail } from "../lib/icons/Email.svg";
import { ReactComponent as UserPass } from "../../../shared/lib/icons/svg/Feedback/pass.svg";  
import useTimeZone from "../../../shared/hooks/useTimeZone";
import AuthVariants from "../../../Pages/login-user-page/AuthVariants/AuthVariants";
import FailureAuth from "../../../Pages/login-user-page/AuthVariants/AuthStatusPage/FailureAuth";
import Loader from "../../../shared/ui/loader-circle/lodaer-circle";
import { getUserData } from "../../../features/user/getUserData";
import DefaultInput from "../../../shared/ui/DefaultInput/DefaultInput";
import { Button } from "../../../shared/ui/Button";
import ToolTipComponent from "../../../shared/ui/Tooltips/Tooltip";

import { consumeVkCallback } from '../../../Pages/login-user-page/AuthVariants/vk-auth-flow';

export default function AuthUser() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isDisabled, setIsDisabled] = useState(true);
  const [isAuthError, setIsAuthError] = useState(false);
  const [autoOpen, setAutoOpen] = useState(false);
  const [checkedPrivacy, setCheckedPrivacy] = useState(true);
  const [errorAuth, setErrorAuth] = useState({
    emailErr: '',
    typeAuth: ''
  })
  const navigate = useNavigate();
  const location = useLocation();
  const requestedReturn = location.state?.subscriptionReturn
    ?? new URLSearchParams(location.search).get('subscriptionReturn');
  const subscriptionReturn = resolveSubscriptionReturn(requestedReturn);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [isLoadingAuthSocial, setIsLoadingAuthSocial] = useState(false)
  const focusEmail = document.getElementById('email')
  const { getCurrentTimeZone } = useTimeZone()
  let arrErrors = new Array([]);
  const [dataErrors, setDataErrors] = useState([]);
  const [windowScreen, setWindowScreen] = useState(window.screen.width);

  const stylesList = {
    width: windowScreen > 410 ? '334px' : '268px',
    backgroundColor: '#F8C440',
    top: windowScreen > 410 ? '120%' : '-240%',
    left: windowScreen > 410 && windowScreen < 992 ? '-135%' : windowScreen < 410 ? '16%' : '-7%',
    transform: windowScreen > 410 ? null : 'translateX(-25%)'
  }
  const stylesListArrow = {
    top: windowScreen > 410 ? '-8%' : '80%',
    left: windowScreen > 410 ? '7.5%' : '10%'
  }

  useEffect(() => {
    const handleUpdateScreenWidth = () => {
      setWindowScreen(window.screen.width)
    }

    window.addEventListener('resize', handleUpdateScreenWidth);

    return () => {
      window.removeEventListener('resize', handleUpdateScreenWidth);
    };
  }, [])

  const hadnleLogin = async (res) => {
    setLoading(false)
    sendDataLayer('auth_password', 'auth_password')
    localStorage.setItem('userID', res.data.id);
    localStorage.setItem('firstName', res.data.firsName);
    localStorage.setItem('lastName', res.data.lastName === null ? '' : res.data.lastName);    
    localStorage.setItem('interceptorTry', 'false');
    startSession(res.data.token, res.data.refreshToken);
    navigate(subscriptionReturn);
    dispatch(getUserData())
  }

  useEffect(() => {
    if (localStorage.getItem('userID')) {
      navigate(subscriptionReturn, { replace: true })
    }
  }, [])// eslint-disable-line react-hooks/exhaustive-deps

  /* eslint-disable-next-line */
  let emailReg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/
  /* eslint-disable-next-line */
  useEffect(() => {
    if ((email !== '') && (password !== '')) {
      setIsDisabled(false)
    } else {
      setIsDisabled(true)
    }
  }, [email, password]);
  
  const socialCallbacks = useRef({ hadnleLogin, getCurrentTimeZone });
  socialCallbacks.current = { hadnleLogin, getCurrentTimeZone };
  useEffect(() => {
    if (typeof BroadcastChannel === 'undefined') return;
    const channel = new BroadcastChannel('Auth');
    let exchanging = false;
    let disposed = false;
    channel.onmessage = async (event) => {
      const { type, payload } = event.data ?? {};
      if (!['vk', 'yandex'].includes(type) || !payload || exchanging) return;
      try {
        const credentials = type === 'vk' ? consumeVkCallback(payload) : { code: payload.code };
        if (!credentials) return; // Callback belongs to another tab, expired page or consumed attempt.
        if (payload.error || !credentials.code) throw new Error('Вход отменён или отклонён. Начните вход заново.');
        exchanging = true;
        setIsLoadingAuthSocial(true);
        const response = await request.post(`/auth/${type}/callback`, {
          ...credentials, timeZoneId: socialCallbacks.current.getCurrentTimeZone(),
        }, { timeout: 60000 });
        if (!disposed) await socialCallbacks.current.hadnleLogin(response);
      } catch (error) {
        if (disposed) return;
        const text = typeof error.response?.data === 'string' ? error.response.data
          : error.response || error.request ? 'Не удалось завершить вход. Начните вход заново.'
          : error.message || 'Не удалось завершить вход. Начните вход заново.';
        const email = text.match(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/)?.[0] ?? '';
        setErrorAuth({ emailErr: email, typeAuth: type, message: email ? '' : text });
        setIsAuthError(true);
      } finally {
        exchanging = false;
        if (!disposed) setIsLoadingAuthSocial(false);
      }
    };
    return () => { disposed = true; channel.close(); };
  }, []);

  const authHandler = () => {
    if (!checkedPrivacy) {
      setAutoOpen(true)
    }
  }
  
  function handleSubmit() {
    // e.preventDefault();
    if (emailReg.test(email) === true) {
      setLoading(true)
      setDataErrors([])
      request.post('/Account/Login', {  
            email: email,
            password: password})
            .then(res => {
              hadnleLogin(res)
            })
            .catch((error) => {
              setLoading(false)
              
              if (error.response.data.errors) {
                let arrGetError = Object.entries(error.response.data.errors)
                  arrGetError.forEach(([key, value]) => {
                    value.map(err => arrErrors.push({key, err}))
                    setDataErrors(arrErrors)
                  })
              }
            })
            // .catch((error) => {
            //   setLoading(false)
            //   if(error.response.data.errors.Email != null){
            //     let lengthEmail = error.response.data.errors.Email.length;
            //     let errors = "";
            //     for(let i = 0; i < lengthEmail; i++){
            //         errors += "* " + error.response.data.errors.Email[i] + "\r\n";
            //     }
            //     setErrorEmail(errors)
            //     setIsHiddenEmailErr(false);
            //   }else{
            //     setErrorEmail("");
            //     setIsHiddenEmailErr(true);
            //   }
  
            //   if(error.response.data.errors.Password != null){
            //     let lengthPassword = error.response.data.errors.Password.length;
            //     let errors = "";
            //     for(let i = 0; i < lengthPassword; i++ ){
            //       errors += "* " + error.response.data.errors.Password[i] + "\r\n";
            //     }
            //     setErrorPassword(errors)
            //     setIsHiddenPassErr(false);
            //   }else{
            //     setErrorPassword("");
            //     setIsHiddenPassErr(true);
            //   }
              
            // })
          }
    else {
      arrErrors.push({key: 'Email', err: 'некорректный email'});
      setDataErrors(arrErrors)
      focusEmail.focus()
    }
  }

  if (isLoadingAuthSocial) {
    return (
      <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}>
        <Loader />
      </div>
    )
  }

            return (
              <>
                {
                  isAuthError ? <FailureAuth emailErr={errorAuth.emailErr} 
                                              typeAuth={errorAuth.typeAuth}
                                              message={errorAuth.message}
                                              setIsAuthError={setIsAuthError}/> : 
                  <div className="register-form__page">
                      <div className="register-form__container">
                      <h2 className="register-form__heading">Вход в аккаунт</h2>
                        <form autoComplete="on" onSubmit={handleSubmit} className='register-form__form'>
                          <div style={{width: "100%"}}>
                          <DefaultInput logo={<UserEmail width={'18px'} height={'18px'}/>} placeHolder="E-mail" inputType="email" inputValue={email} onChangeFunc={setEmail}>
                            <Validation data={dataErrors} keyItem={'Email'}/>
                          </DefaultInput>
                          </div>
                          <div style={{width: "100%"}}>
                            <DefaultInput logo={<UserPass />} placeHolder="Пароль" inputType="password" inputValue={password} onChangeFunc={setPassword}>
                              <Validation data={dataErrors} keyItem={'Password'}/>
                            </DefaultInput>
                          </div>
                            <Button onClickFunc={handleSubmit} btnSize="xl" btnType="filled" title="Войти" disabled={isDisabled} loading={loading} />
                            <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                              <p className="login-description">
                                  Забыли пароль? <Link to="/forgot_password">Восстановить</Link>
                              </p>
                              <p className="login-description">
                                Еще нет аккаунта? <Link to="/register">Зарегистрироваться</Link>
                              </p>
                            </div>
                            <ToolTipComponent autoOpen={autoOpen} autoOpenHandler={setAutoOpen} stylesList={stylesList} stylesListArrow={stylesListArrow} tooltipDescription="Необходимо дать согласие на обработку персональных данных">
                              <div className="privacy-check checkList">
                                <label className="label_to_checkBox privacy-label" style={{alignItems: 'center'}}>
                                  <input type="checkbox" className="checkList_checkbox" checked={checkedPrivacy} onClick={() => setCheckedPrivacy(!checkedPrivacy)}/>
                                  <span></span>
                                  Я принимаю 
                                  <a href="http://localhost:3000/privacy" rel="noreferrer" className="privacy-link" target="_blank" style={{marginLeft: '3px'}}>Политику конфиденциальности</a> 
                                </label>
                              </div>
                            </ToolTipComponent>
                        </form>
                        <AuthVariants isPrivacyPolicy={checkedPrivacy} onClickFunction={() => authHandler()}/>
                      </div>
                  </div>
                }
              </>               
            )
}
